import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { APIService } from '../shared/service/api.service';
import { FormAreasService } from './formAreas.service';

@Component({
  selector: 'app-sugestoes-areas',
  templateUrl: './sugestoes-areas.component.html',
  styleUrls: ['./sugestoes-areas.component.scss']
})
export class SugestoesAreasComponent implements OnInit {

  formulario: FormGroup;
  regexEmail: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  localAlteracao: any;
  camposAreaTecnologica: any;
  textoTermo: string;

  eixos: any[];
  areas: any[];

  enviouFormulario = false;
  formErro = false;
  erro = false;
  formularioRecebido = false;

  mostarPopUp = false;
  resposta: any;

  qtdCamposAdicionados = 0;

  constructor(private api: APIService, private formService: FormAreasService) { }

  ngOnInit(): void {
    const { localAlteracao, camposAreaTecnologica, textoTermo } = this.formService.getFormFields();
    this.localAlteracao = localAlteracao;
    this.camposAreaTecnologica = camposAreaTecnologica;
    this.textoTermo = textoTermo;

    this.api.getEixosConsultaAreas().subscribe(res => {
      this.eixos = res;
    });

    this.gerarFormulario();

    // Adiciona campos da específicos da área tecnológica
    this.camposAreaTecnologica.forEach((campo) => {
      this.formulario.addControl(campo.fields.proposta, new FormControl(null, Validators.maxLength(1000)));
      this.formulario.addControl(campo.fields.justificativa, new FormControl(null, Validators.maxLength(1000)));
    });

  }

  gerarFormulario(): void {
    this.formulario = new FormGroup({
      nome: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.pattern(this.regexEmail)]),
      instituicaoEmpresa: new FormControl(null),
      eixoTecnologicoCatalogosId: new FormControl('', Validators.required),
      sugestaoPara: new FormControl(null, Validators.required),

      areaTecnologicaCatalogosId: new FormControl(null),

      propostaNovaAreaTecnologica: new FormControl(null),
      justificativaNovaAreaTecnologica: new FormControl(null),

      aceitaTermo: new FormControl(false, Validators.requiredTrue),
      reCaptcha: new FormControl(null, [Validators.required]),
    });

    this.formulario.get('sugestaoPara').valueChanges.subscribe(value => {
      this.verificaSelecaoDaSugestao(value);
    });

    this.formulario.get('eixoTecnologicoCatalogosId').valueChanges.subscribe(value => {
      if (value){
        this.api.getAreasConsultaAreas(value).subscribe(res => {
          this.areas = res;
        });
      }
    });
  }

  verificaSelecaoDaSugestao(selecao: string): void {
    if (selecao === 'Área tecnológica (criação de uma nova área)') {
      this.adicionaValidadorCampoRequerido(['propostaNovaAreaTecnologica', 'justificativaNovaAreaTecnologica']);
      this.limpaValidadores(['areaTecnologicaCatalogosId']);

      this.camposAreaTecnologica.forEach(campo => {
        this.limpaValidadores([campo.fields.proposta]);
        this.limpaValidadores([campo.fields.justificativa]);
      });
    }
    else {
      this.adicionaValidadorCampoRequerido(['areaTecnologicaCatalogosId']);
      this.limpaValidadores(['propostaNovaAreaTecnologica', 'justificativaNovaAreaTecnologica']);
    }
  }

  adicionaValidadorCampoRequerido(campos: string[]) {
    campos.forEach((campo) => {
      this.formulario.get(campo).reset();
      this.formulario.controls[campo].setValidators([Validators.required, Validators.maxLength(1000)]);
      this.formulario.controls[campo].updateValueAndValidity();
    });
  }

  limpaValidadores(campos: string[]) {
    campos.forEach((campo) => {
      this.formulario.controls[campo].clearValidators();
      this.formulario.controls[campo].updateValueAndValidity();
      this.formulario.get(campo).reset();
    });
  }

  add() {
    this.qtdCamposAdicionados = this.qtdCamposAdicionados + 1;
  }

  sub() {
    this.qtdCamposAdicionados = this.qtdCamposAdicionados - 1;
  }

  cancelar() {
    if (this.formularioRecebido){
      window.location.reload();
      return;
    }
    this.mostarPopUp = false;
  }

  onSubimitFormulario(): void {
    this.erro = false;
    this.formErro = false;
    this.enviouFormulario = true;

    if (this.formulario.invalid) {
      this.formulario.markAllAsTouched();
      this.formErro = true;
      setTimeout(() => {
        this.enviouFormulario = false;
      }, 200);
      return;
    }

    // Confere se todos os campos da área foram preenchidos
    if (this.formulario.get('sugestaoPara').value === 'Área tecnológica (alteração de uma área proposta)') {
      if (this.qtdCamposAdicionados === 0) {
        this.formulario.setErrors({nenhumCampoAdicionado: true});
        this.formErro = true;
        setTimeout(() => {
          this.enviouFormulario = false;
        }, 200);
        return;
      }
    }

    const url = window.location.href;
    const form = { ...this.formulario.value, linkFormulario: url };
    this.mostarPopUp = true;

    this.api.postFormConsultaAreas(form).subscribe(response => {
      setTimeout(() => {
        this.resposta = response;
        this.formulario.reset();
        this.formularioRecebido = true;
      }, 300);
    },
      (error) => {
        this.erro = true;
      }
    );


  }

}
